import Row from '@sdk/components/ui/spacing/Row';
import Text14 from '@sdk/components/ui/typography/Text14';
import gettext from '@sdk/lang/gettext';
import { ThemeColorType } from '@sdk/theme/ThemeColorType';
import H3 from '@sdk/components/ui/typography/H3';
import { useState } from 'react';

import YoutubeOpenerPng from '@web/assets/svg/images/youtube-v3.png';
import ToastIntegrationSvg from '@web/assets/images/toast-integration.svg';
import { useToastShiftScheduleModal } from '@web/integrations/shiftScheduleImport/ToastShiftScheduleModalProvider';
import CloseButtonSvg from '@web/assets/svg/UI/close.svg';

import {
  BoldHeader,
  CloseModalButtonWrapper,
  Container,
  ModalText,
  TextLine,
  VideoOpener,
  VideoWrapper,
} from './toastModalContent.styles';

const YOUTUBE_EMBED_URL = 'https://www.youtube.com/embed/_iGxEMSmvnI';

type Props = {
  displayCloseButton: boolean;
};

const SlideA = ({ displayCloseButton }: Props) => {
  const [isOpenerVisible, setIsOpenerVisible] = useState(true);
  const { close } = useToastShiftScheduleModal();
  const playVideo = () => {
    setIsOpenerVisible(false);
  };
  return (
    <>
      {displayCloseButton && (
        <CloseModalButtonWrapper className={'guard-close-button'}>
          <span className="pull-right">
            <button type="button" className="btn btn-icon" onClick={() => close()}>
              <CloseButtonSvg alt={'Close Import Shift Modal Button'} />
            </button>
          </span>
        </CloseModalButtonWrapper>
      )}

      <Container alignItems="center">
        <Row pTop={40}>
          <VideoWrapper>
            <iframe
              width="384"
              height="216"
              src={`${YOUTUBE_EMBED_URL}?modestbranding=1&autoplay=${isOpenerVisible ? 0 : 1}`}
              referrerPolicy="strict-origin-when-cross-origin"
              allowFullScreen
            />

            {isOpenerVisible && (
              <VideoOpener onClick={playVideo}>
                <img src={YoutubeOpenerPng} />
              </VideoOpener>
            )}
          </VideoWrapper>
        </Row>
        <Row pTop={20}>
          <BoldHeader>{gettext('Toast integration complete')}</BoldHeader>
        </Row>
        <Row pTop={10}>
          <ModalText>{gettext('You have successfully connected Sling with Toast!')}</ModalText>
        </Row>
        <Row pBottom={20} pLeft={80} pRight={80}>
          <TextLine>
            <ModalText>{gettext('Sling will now automatically sync')}&nbsp;</ModalText>
            <ModalText bold>
              {gettext('employees, wages, locations, positions, timesheets')}&nbsp;
            </ModalText>
            <ModalText>{gettext('and')}&nbsp;</ModalText>
            <ModalText bold>{gettext('net sales')}&nbsp;</ModalText>
            <ModalText>
              {gettext('from Toast every 15 minutes, keeping data up-to-date.')}
            </ModalText>
          </TextLine>
        </Row>
      </Container>
    </>
  );
};

const SlideALegacy = () => {
  const { close } = useToastShiftScheduleModal();
  return (
    <>
      <CloseModalButtonWrapper className={'guard-close-button'}>
        <span className="pull-right">
          <button type="button" className="btn btn-icon" onClick={() => close()}>
            <CloseButtonSvg alt={'Close Import Shift Modal Button'} />
          </button>
        </span>
      </CloseModalButtonWrapper>
      <Container pTop={20} alignItems="center">
        <ToastIntegrationSvg />
        <Row pTop={20}>
          <H3 themeColor={ThemeColorType.primary}>{gettext('Toast integration complete')}</H3>
        </Row>
        <Row pTop={10}>
          <Text14 themeColor={ThemeColorType.gray}>
            {gettext('You have successfully connected Sling with Toast!')}
          </Text14>
        </Row>
        <Row pBottom={20}>
          <TextLine>
            <Text14 themeColor={ThemeColorType.gray}>
              {gettext('Sling will now automatically sync')}&nbsp;
            </Text14>
            <Text14 themeColor={ThemeColorType.gray} bold>
              {gettext('employees, wages, locations, positions, timesheets')}&nbsp;
            </Text14>
            <Text14 themeColor={ThemeColorType.gray}>{gettext('and')}&nbsp;</Text14>
            <Text14 themeColor={ThemeColorType.gray} bold>
              {gettext('net sales')}&nbsp;
            </Text14>
            <Text14 themeColor={ThemeColorType.gray}>
              {gettext('from Toast every 15 minutes, keeping data up-to-date.')}
            </Text14>
          </TextLine>
        </Row>
      </Container>
    </>
  );
};

export { SlideA, SlideALegacy };
